export { ExternalSectionRenderer } from './externalSections.comp';
